module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-L-13.f1eb909b.png";